import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiListDataService } from './api.list-data.service';
import { ProjectItemModel } from '../../models';

@Injectable({
    providedIn: 'root',
})
export class ApiProjectItemService extends ApiListDataService<ProjectItemModel, ProjectItemModel> {
    constructor(http: HttpClient) {
        super(http, '/ProjectItem/');
    }
}
